<template>
  <div class="HubIOSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubIOSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubIOSettings-main lxn-pos-rel">
      <div class="HubIOSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{getType === 'internal' ? $store.getters.language.texts.HubIOSettings_title1 : getType === 'expansion1' ? $store.getters.language.texts.HubIOSettings_title2 : $store.getters.language.texts.HubIOSettings_title3}}
          </template>
          <template v-slot:body>
            <div v-if="hasI" class="lxn-margin-auto lxn-w100">
              <CustomButton @click="iSettings" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
                {{$store.getters.language.texts.HubIOSettings_button1}}
              </CustomButton>
            </div>

            <div v-if="haso" class="HubIOSettings-wrapper-users lxn-margin-auto lxn-w100">
              <CustomButton @click="oSettings" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
                {{$store.getters.language.texts.HubIOSettings_button2}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'

export default {
  name: 'HubIOSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    ButtonIcon,
  },
  data: function () {
    return {
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      type: this.$route.params.type,
      activeBoxIndex: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).color,
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    getType: function () {
      return this.type;
    },
    hasI: function () {
      return true;
    },
    haso: function () {
      return true;
    },
  },
  methods: {
    goBack: function () {
      this.$router.push('/node2Settings/' + this.node.uuid);
    },
    iSettings: function () {
      this.$router.push('/hubInputSettings/' + this.node.uuid + '/' + this.type);
    },
    oSettings: function () {
      this.$router.push('/hubOutputSettings/' + this.node.uuid + '/' + this.type);
    },
  }
}
</script>

<style>
  .HubIOSettings-topCurve-wrapper {
    height: 200px;
  }
  .HubIOSettings-main {
    z-index: 2;
  }
  .HubIOSettings-main-wrapper {
    min-height: 150px;
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .HubIOSettings-wrapper-users {
    height: 50px;
    background-color: #FFFFFF;
    margin-top: 14px;
  }
</style>
